// ANNOUNCEMENT HEIGHT GET -- START
function updateAnnouncementBarHeight() {
  const element = document.querySelector('.announcement-bar-section');
  const height = element.offsetHeight;
  document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
}

updateAnnouncementBarHeight();
window.addEventListener('resize', updateAnnouncementBarHeight);
// ANNOUNCEMENT HEIGHT GET -- END


// BANNER COLLECTION -- START

// $(document).ready(function () {
//    var $swiperSelector = $(".banner_collection_slider"),
//       dragSize = $swiperSelector.data("drag-size") ? $swiperSelector.data("drag-size") : 50,
//       freeMode = $swiperSelector.data("free-mode") ? $swiperSelector.data("free-mode") : !1,
//       loop = $swiperSelector.data("loop") ? $swiperSelector.data("loop") : !1,
//       slidesDesktop = $swiperSelector.data("slides-desktop") ? $swiperSelector.data("slides-desktop") : 5,
//       slidesLaptop = $swiperSelector.data("slides-laptop") ? $swiperSelector.data("slides-laptop") : 4,
//       slidesTablet = $swiperSelector.data("slides-tablet") ? $swiperSelector.data("slides-tablet") : 3,
//       slidesMobile = $swiperSelector.data("slides-mobile") ? $swiperSelector.data("slides-mobile") : 2,
//       slidesMobileinner = $swiperSelector.data("slides-mobile-inner") ? $swiperSelector.data("slides-mobile-inner") : 1.2;
//    if (jQuery(window).width() < 751) {
//       var lengthSize = Math.round(jQuery(".pdr-count").val() / 2);
//       dragSize = dragSize * lengthSize
//    } else dragSize = dragSize * jQuery(".pdr-count").val();
//    console.log("dragSize", dragSize), setTimeout(function () {
//       var swiper = new Swiper(".banner_collection_slider", {
//          direction: "horizontal",
//          loop,
//          freeMode,
//          spaceBetween: 40,
//          breakpoints: {
//             1920: {
//                slidesPerView: slidesDesktop
//             },
//             1220: {
//                slidesPerView: slidesLaptop,
//                spaceBetween: 30
//             },
//             820: {
//                slidesPerView: slidesTablet,
//                spaceBetween: 24
//             },
//             576: {
//                slidesPerView: slidesMobile,
//                spaceBetween: 20
//             },
//             320: {
//                slidesPerView: slidesMobileinner,
//                spaceBetween: 12
//             }
//          },
//          navigation: {
//             nextEl: ".swiper-button-next",
//             prevEl: ".swiper-button-prev"
//          },
//          scrollbar: {
//             el: ".swiper-scrollbar",
//             draggable: !0,
//             dragSize
//          }
//       })
//    }, 500)
// });
// BANNER COLLECTION -- END

// PEOPLE VIDEOS -- START

$('.people_video_slider').slick({
  centerMode: false,
  centerPadding: '20px',
  slidesToShow: 3,
  arrows: false,
  loop: false,
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick"
    },
    {
      breakpoint: 1120,
      settings: {
        dots: true,
        slidesToShow: 4
      }
    },
    {
      breakpoint: 991,
      settings: {
        dots: true,
        slidesToShow: 3
      }
    },
    {
      breakpoint: 767,
      settings: {
        dots: true,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        dots: true,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});

// PEOPLE VIDEOS -- END


// REVIEW SLIDER -- START

$(document).ready(function () {
  $(".review_slider").slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  });
});

// REVIEW SLIDER -- END

// ===== tabing_faq ===== //

  $(document).ready(function(){
  $('ul.faq_tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('ul.faq_tabs li').removeClass('active');
    $('.faq-content').removeClass('active');

    $(this).addClass('active');
    $('.faq-content[id="' + tab_id + '"]').addClass('active');
  });
});


    document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector(".accordion-item-header")!=null){
      const firstAccordionItemHeader = document.querySelector(".accordion-item-header");
      const firstAccordionItemBody = firstAccordionItemHeader.nextElementSibling;
  
      // Open the first accordion item by default
      firstAccordionItemHeader.classList.add("active");
      firstAccordionItemBody.style.maxHeight =
        firstAccordionItemBody.scrollHeight + "px";
    }

    const accordionItemHeaders = document.querySelectorAll(
      ".accordion-item-header"
    );

    accordionItemHeaders.forEach((accordionItemHeader) => {
      accordionItemHeader.addEventListener("click", (event) => {
        const currentlyActiveAccordionItemHeader = document.querySelector(
          ".accordion-item-header.active"
        );
        if (
          currentlyActiveAccordionItemHeader &&
          currentlyActiveAccordionItemHeader !== accordionItemHeader
        ) {
          currentlyActiveAccordionItemHeader.classList.toggle("active");
          currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
        }
        accordionItemHeader.classList.toggle("active");
        const accordionItemBody = accordionItemHeader.nextElementSibling;
        if (accordionItemHeader.classList.contains("active")) {
          accordionItemBody.style.maxHeight =
            accordionItemBody.scrollHeight + "px";
        } else {
          accordionItemBody.style.maxHeight = 0;
        }
      });
    });
  });

/*:::::::::::::::::::::::: CART DRAWER PROGRESS BAR START JS :::::::::::::::::::::::: */
jQuery(document).ready(function(){
  setInterval(function(){
  if(jQuery('.cart_progress_block').find('.cart_progress_col.cp_col__second').length>0){
      var getCurrency = '';
      if(jQuery('.doubly-wrapper').find('.currency-switcher').length>0){
        getCurrency = jQuery('.doubly-wrapper').find('.currency-switcher').find('option:selected').val();
        //console.log("getCurrency",getCurrency);
        var currencySymbol = '₹';
        if(getCurrency=='AED'){
          currencySymbol = "د.إ";
        }else if(getCurrency=='SAR'){
          currencySymbol = "ر.س";
        }
        jQuery('.cart_progress_block').find('.cart_progress_col.cp_col__second').find('.cp_col_icon').text(currencySymbol);
        jQuery('.cart_progress_block').find('.cart_progress_col.cp_col__third').find('.cp_col_icon').text(currencySymbol);
      }
    }
   },100);
});
/*:::::::::::::::::::::::: CART DRAWER PROGRESS BAR END JS :::::::::::::::::::::::::: */

/*::::::::::::::::::::::::  Wishlist Code start here :::::::::::::::::::::::: */

// Wishlist feature: Add or remove the current product from the wishlist
jQuery(document).on("click", ".product-wish-btn.wishlist_button", function () {
  var flag='';
  if(jQuery(this).hasClass('remove_wishlist_product')){
    flag=1;
  }
  toggleWishlist(jQuery(this),flag);
});

function toggleWishlist(objClick, flag = "") {
  var optionAllval = "";
  if (flag == "") {
    optionAllval = trialcombinationVariant();
  }
  var productId = objClick.attr("data-pid");
  var ptitle = objClick.attr("data-ptitle");
  var pimage = objClick.attr("data-pimage");
  var pprice = objClick.attr("data-pprice");
  var cpprice = objClick.attr("data-cpprice");
  var pslug = objClick.attr("data-pslug");
  var productVendor = objClick.attr("data-vendor");
  var productUrl = objClick.attr("data-url");
  if (productUrl && productUrl.includes("?")) {
    productUrl = productUrl.split("?")[0];
  }
  var productSku = objClick.attr("data-sku");
  var priceNormal = objClick.attr("data-pricenormal");
  if (priceNormal == "" || priceNormal == undefined) {
    priceNormal = 0;
  }
  var variantId = objClick.attr("data-variantid");
  var cppriceNormal = objClick.attr("data-cppricenormal");
  if (cppriceNormal == "" || cppriceNormal == undefined) {
    cppriceNormal = 0;
  }
  //console.log("variantId", variantId);
  const pdpData = {
    product_title: ptitle,
    product_image: pimage,
    product_price: pprice,
    product_url: productUrl,
    variant_id:variantId,
    product_id:productId,
    price_normal:priceNormal,
    product_vendor:productVendor,
    compare_normal:cppriceNormal
  };

  let wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
  const isAlreadyInWishlist = wishlistData.some(
    (item) => item.variant_id === pdpData.variant_id
  );
  const wishlistButton = document.getElementsByClassName("wishlist_button")[0];
  //console.log("isAlreadyInWishlist",isAlreadyInWishlist);
  if (!isAlreadyInWishlist) {
    wishlistData.push(pdpData);
    localStorage.setItem("wishlist", JSON.stringify(wishlistData));
    // alert('Product added to wishlist:', pdpData.productTitle);
    if (flag == "") {
      wishlistButton.innerHTML = `<svg class="heart-filled" width="35px" height="35px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.3 5.71002C18.841 5.24601 18.2943 4.87797 17.6917 4.62731C17.0891 4.37666 16.4426 4.2484 15.79 4.25002C15.1373 4.2484 14.4909 4.37666 13.8883 4.62731C13.2857 4.87797 12.739 5.24601 12.28 5.71002L12 6.00002L11.72 5.72001C10.7917 4.79182 9.53273 4.27037 8.22 4.27037C6.90726 4.27037 5.64829 4.79182 4.72 5.72001C3.80386 6.65466 3.29071 7.91125 3.29071 9.22002C3.29071 10.5288 3.80386 11.7854 4.72 12.72L11.49 19.51C11.6306 19.6505 11.8212 19.7294 12.02 19.7294C12.2187 19.7294 12.4094 19.6505 12.55 19.51L19.32 12.72C20.2365 11.7823 20.7479 10.5221 20.7442 9.21092C20.7405 7.89973 20.2218 6.64248 19.3 5.71002Z" fill="#000000"/>
      </svg>`;
    }
  } else {
    wishlistData = wishlistData.filter(
      (item) => item.variant_id !== pdpData.variant_id
    );
    localStorage.setItem("wishlist", JSON.stringify(wishlistData));
    // alert('Product removed from wishlist:', pdpData.productTitle);
    if (flag == "") {
      wishlistButton.innerHTML = `<svg class="heart-outline" width="40px" height="40px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      
      <rect x="0" fill="none" width="24" height="24"/>
      
      <g>
      
      <path d="M16.5 4.5c2.206 0 4 1.794 4 4 0 4.67-5.543 8.94-8.5 11.023C9.043 17.44 3.5 13.17 3.5 8.5c0-2.206 1.794-4 4-4 1.298 0 2.522.638 3.273 1.706L12 7.953l1.227-1.746c.75-1.07 1.975-1.707 3.273-1.707m0-1.5c-1.862 0-3.505.928-4.5 2.344C11.005 3.928 9.362 3 7.5 3 4.462 3 2 5.462 2 8.5c0 5.72 6.5 10.438 10 12.85 3.5-2.412 10-7.13 10-12.85C22 5.462 19.538 3 16.5 3z"/>
      
      </g>
      
      </svg>`;
    }
  }
  // Update the display after modifying the wishlist
  //displayWishlist();
  addedWishListFill();
  if (flag != "") {
    displayWishlist();
  }
}

//Remove the specified product from the wishlist
function removeFromWishlist(variantId) {
  let wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
  wishlistData = wishlistData.filter((item) => item.variant_id !== variantId);
  localStorage.setItem("wishlist", JSON.stringify(wishlistData));
  // Update the display after removing from the wishlist
  displayWishlist();
}

// Display wishlist items
function displayWishlist() {
  const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
  //if(jQuery('.js-wishlistBlock').length!=0){
  const wishlistBlock = document.querySelector(".js-wishlistBlock");
  if (wishlistData.length === 0 && wishlistBlock!=null) {
    console.log("Wishlist is empty");
    wishlistBlock.innerHTML = "Wishlist is empty";
    wishlistBlock.classList.add('is-empty-wishlist');
    return;
  }
  var getCurrency = 'AED';
  if(jQuery('.doubly-wrapper').find('.currency-switcher').length>0){
    getCurrency = jQuery('.doubly-wrapper').find('.currency-switcher').find('option:selected').val();
  }
  var loaderHtml = '<div class="loading-overlay__spinner hidden">';
  loaderHtml +=
    '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">';
  loaderHtml +=
    '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>';
  loaderHtml += "</svg>";
  loaderHtml += "</div>";
  const wishlistHtml = wishlistData
    .map((item) => {
      return `<li class="grid__item scroll-trigger animate--slide-in">
            <div class="wishlist-product__list card-wrapper product-card-wrapper underline-links-hover">
              <div class="card card--standard card--media" style="--ratio-percent: 125.0%;">
                <div class="card__inner color-scheme-1 gradient ratio" style="--ratio-percent: 125.0%;">
                  <div class="card__media">
                    <div class="media media--transparent media--hover-effect">
                      <button
                        class="product-wish-btn wishlist_button remove_wishlist_product"
                        data-url="${item.product_url}"
                        data-pimage="${item.product_image}"
                        data-pprice="${item.product_price}"
                        data-pricenormal="${item.price_normal}"
                        data-cppricenormal="${item.compare_normal}"
                        data-ptitle="${item.product_title}"
                        data-pid="${item.product_id}"
                        data-vendor="${item.product_vendor}"
                        data-variantid="${item.variant_id}"
                      >
                        <svg class="heart-filled" width="35px" height="35px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M19.3 5.71002C18.841 5.24601 18.2943 4.87797 17.6917 4.62731C17.0891 4.37666 16.4426 4.2484 15.79 4.25002C15.1373 4.2484 14.4909 4.37666 13.8883 4.62731C13.2857 4.87797 12.739 5.24601 12.28 5.71002L12 6.00002L11.72 5.72001C10.7917 4.79182 9.53273 4.27037 8.22 4.27037C6.90726 4.27037 5.64829 4.79182 4.72 5.72001C3.80386 6.65466 3.29071 7.91125 3.29071 9.22002C3.29071 10.5288 3.80386 11.7854 4.72 12.72L11.49 19.51C11.6306 19.6505 11.8212 19.7294 12.02 19.7294C12.2187 19.7294 12.4094 19.6505 12.55 19.51L19.32 12.72C20.2365 11.7823 20.7479 10.5221 20.7442 9.21092C20.7405 7.89973 20.2218 6.64248 19.3 5.71002Z" fill="#000000"/>
                        </svg>
                      </button>
                      <a href="${item.product_url}">
                        <img src="${item.product_image}" alt="${item.product_title}">
                      </a>
                    </div>
                  </div>
                  <div class="card__content">
                    <div class="card__information">
                      <h3 class="card__heading">
                        <a href="${item.product_url}" class="full-unstyled-link">${item.product_title}</a>
                      </h3>
                    </div>
                    <div class="card__badge bottom left"></div>
                  </div>
                </div>
                <div class="card__content">
                  <div class="card__information">
                    <h3 class="card__heading h5">
                      <a href="${item.product_url}" class="full-unstyled-link">${item.product_title}</a>
                    </h3>
                    <div class="card-information">
                      <span class="caption-large light"></span>
                      <div class="price">
                        <div class="price__container">
                          <div class="price__regular">
                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                            <span class="price-item price-item--regular">
                              ${getCurrency} ${item.product_price}
                            </span>
                          </div>
                          <div class="price__sale">
                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                            <span><s class="price-item price-item--regular"></s></span>
                            <span class="visually-hidden visually-hidden--inline">Sale price</span>
                            <span class="price-item price-item--sale price-item--last">
                              ${getCurrency} ${item.product_price}
                            </span>
                          </div>
                          <small class="unit-price caption hidden">
                            <span class="visually-hidden">Unit price</span>
                            <span class="price-item price-item--last">
                              <span></span>
                              <span aria-hidden="true">/</span>
                              <span class="visually-hidden">&nbsp;per&nbsp;</span>
                              <span></span>
                            </span>
                          </small>
                        </div>
                      </div>
                    </div>
                    <div class="card-product_atcbtn quick-add no-js-hidden">
                      <product-form data-section-id="template--19640021745903__featured_collection">
                        <form method="post" action="/cart/add" id="quick-add-template--18872854216804__featured_collection${item.product_id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                          <input type="hidden" name="form_type" value="product">
                          <input type="hidden" name="utf8" value="✓">
                          <input type="hidden" name="id" value="${item.variant_id}" class="product-variant-id">
                          <button id="quick-add-template--18872854216804__featured_collection${item.product_id}-submit" type="submit" name="add" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog" aria-labelledby="quick-add-template--19640021745903__product-grid${item.product_id}-submit title-template--19640021745903__product-grid-${item.product_id}" aria-live="polite" data-sold-out-message="true">
                            <span>
                              <svg enable-background="new 0 0 50 50" height="50px" width="50px" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
                                <rect fill="none" height="50" width="50"></rect>
                                <line fill="none" stroke="#000000" stroke-miterlimit="10" stroke-width="4" x1="9" x2="41" y1="25" y2="25"></line>
                                <line fill="none" stroke="#000000" stroke-miterlimit="10" stroke-width="4" x1="25" x2="25" y1="9" y2="41"></line>
                              </svg>
                            </span>
                            <span class="sold-out-message hidden">Sold out</span>
                            <div class="loading__spinner hidden">
                              <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                                <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
                              </svg>
                            </div>
                          </button>
                          <input type="hidden" name="product-id" value="${item.product_id}">
                          <input type="hidden" name="section-id" value="template--19640021745903__featured_collection">
                        </form>
                      </product-form>
                    </div>
                    <div class="card__badge bottom left"></div>
                  </div>
                </div>
              </div>
            </div>
          </li>`;
    })
    .join("");

  // Add a check to ensure the element is not null before setting innerHTML
  if (wishlistBlock) {
    wishlistBlock.innerHTML = '<div class="tab-content active"><ul class="grid product-grid contains-card contains-card--product contains-card--standard grid--5-col-desktop grid--2-col-tablet-down" role="list">'+wishlistHtml+'</ul></div>';
  } else {
    //console.error('Element with class "js-wishlistBlock" not found');
  }
  //}
}

// Execute this function on DOM content load
jQuery(document).ready(function () {
  setTimeout(function(){
    addedWishListFill();
  },1000);
  // Display wishlist items
  displayWishlist();
});
var recommendTriggered = false;
jQuery(window).scroll(function(){
  if(!recommendTriggered && jQuery('.content-for-layout').find('.related-products.product-recommendations--loaded').length>0){
    var recommendSection = jQuery('.content-for-layout').find('.related-products.product-recommendations--loaded').offset().top
    //console.log("recommendSection",recommendSection);
    addedWishListFill();
    recommendTriggered = true;
  }
});

function addedWishListFill() {
  // Fetch the wishlist data from localStorage
  const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
  console.log("wishlistData",wishlistData);
  // Set the initial button text based on whether the product is in the wishlist or not
  if (jQuery(".wishlist_button").length != 0) {
    const wishlistButton = document.querySelector(".wishlist_button"); // Use querySelector instead of getElementsByClassName
    const producturlArr = [];
    if (wishlistButton) {
      jQuery.each(wishlistData, function (index, product) {
        if (product.product_url != "" && product.product_url != undefined) {
          producturlArr.push(product.product_url);
        }
      });
      jQuery(".wishlist_button").each(function () {
        var productUrlwish = jQuery(this).attr("data-url");
        console.log("xproductUrlwish",productUrlwish);
        var wishStr = "";
        if (jQuery.inArray(productUrlwish, producturlArr) !== -1) {
          wishStr = `<svg class="heart-filled" width="35px" height="35px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.3 5.71002C18.841 5.24601 18.2943 4.87797 17.6917 4.62731C17.0891 4.37666 16.4426 4.2484 15.79 4.25002C15.1373 4.2484 14.4909 4.37666 13.8883 4.62731C13.2857 4.87797 12.739 5.24601 12.28 5.71002L12 6.00002L11.72 5.72001C10.7917 4.79182 9.53273 4.27037 8.22 4.27037C6.90726 4.27037 5.64829 4.79182 4.72 5.72001C3.80386 6.65466 3.29071 7.91125 3.29071 9.22002C3.29071 10.5288 3.80386 11.7854 4.72 12.72L11.49 19.51C11.6306 19.6505 11.8212 19.7294 12.02 19.7294C12.2187 19.7294 12.4094 19.6505 12.55 19.51L19.32 12.72C20.2365 11.7823 20.7479 10.5221 20.7442 9.21092C20.7405 7.89973 20.2218 6.64248 19.3 5.71002Z" fill="#000000"/>
              </svg>`;
          if (!jQuery("body").hasClass("collection")) {
            //wishStr+=`<p class="wishlist_text">In Your Wishlist</p>`;
          }
        } else {
          wishStr = `<svg width="35px" height="35px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="heart-outline">
              
              <rect x="0" fill="none" width="24" height="24"/>
              
              <g>
              
              <path d="M16.5 4.5c2.206 0 4 1.794 4 4 0 4.67-5.543 8.94-8.5 11.023C9.043 17.44 3.5 13.17 3.5 8.5c0-2.206 1.794-4 4-4 1.298 0 2.522.638 3.273 1.706L12 7.953l1.227-1.746c.75-1.07 1.975-1.707 3.273-1.707m0-1.5c-1.862 0-3.505.928-4.5 2.344C11.005 3.928 9.362 3 7.5 3 4.462 3 2 5.462 2 8.5c0 5.72 6.5 10.438 10 12.85 3.5-2.412 10-7.13 10-12.85C22 5.462 19.538 3 16.5 3z"/>
              
              </g>
              
              </svg>`;
          if (!jQuery("body").hasClass("collection")) {
           // wishStr+='<p class="wishlist_text">Not In Wishlist</p>';
          }
        }
        jQuery(this).html(wishStr);
      });
    } else {
      console.error('Element with class "wishlist_button" not found');
    }
  }
}
jQuery(document).on("click", ".trial-cart-add-wishlist", function () {
  // Get the `try_cookie_product` cookie
  var match = document.cookie.match(
    new RegExp("(^| )" + "try_cookie_product" + "=([^;]+)")
  );
  var productData = match ? JSON.parse(match[2]) : [];

  if (productData && productData.length > 0) {
    var removeVariantId = jQuery(this).attr("remove-variantid");
    var productId = jQuery(this).attr("remove-pid");

    // Loop through productData and add to wishlist/remove from productData
    jQuery.each(productData, function (index, product) {
      if (product.product_id == productId) {
        let wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
        wishlistData.push(product);
        localStorage.setItem("wishlist", JSON.stringify(wishlistData));

        // Remove the product from productData
        productData.splice(index, 1);

        // Break the loop since the product is found and removed
        return false;
      }
    });

    removeArrayElement(tyrHomeProductArr, "variant_id", removeVariantId);

    // Update the `try_cookie_product` cookie with the modified data
    setCookie("try_cookie_product", "", -1);
    setCookie("try_cookie_product", JSON.stringify(productData), 1);

    // Update the cart item list and UI
    trycartItemList();
    jQuery(".custom-head-trial").text(
      "HOME TRIAL CART (" + productData.length + ")"
    );

    if (productData.length == 0) {
      $(".main-drawer_footer").hide();
      if (jQuery("#total_cart").val() > 0) {
      } else {
        $(".header-and-progress").hide();
        $(".cart-home-wrapper").hide();
      }
    }

    // Show notification and update buttons
    notify("Design Added to favourite", "error");
    jQuery(".trialbtn_" + productId).hide();
    jQuery(".addedbtn_" + productId).show();
    displayWishlist();
  }
});

jQuery(document).on("click", ".cart-add-move-wishlist", function () {
  var variantId = jQuery(this).attr("data-variantid");
  removeCartProductMoveWishlist(variantId);
  toggleWishlist(jQuery(this), 1);
  jQuery("#CartDrawer-CartItems")
    .find('[data-remove="' + variantId + '"]')
    .trigger("click");
});
function trialcombinationVariant() {
  var sizeVal = (caratVal = colorVal = materialVal = "");
  var trialcombinationName = "";
  if (jQuery(".home-product-slider").length != 0) {
    var productID = jQuery(".home-product-slider .slick-active")
      .find('form [name="product-id"]')
      .val();
    sizeVal = jQuery("#product_form_" + productID)
      .find('[name="Size"]:checked')
      .val();
    if (!sizeVal) {
      sizeVal = jQuery("#product_form_" + productID)
        .find('[name="Carat"]:checked')
        .val();
    }
    if (!sizeVal) {
      sizeVal = jQuery("#product_form_" + productID)
        .find('[name="option-Carat"]:checked')
        .val();
    }

    if (!sizeVal) {
      sizeVal = jQuery("#product_form_" + productID)
        .find(".js_product_var_change option:selected")
        .attr("data-option2");
    }
    //console.log("sizeVal", jQuery('#product_form_'+productID).find('.js_product_var_change option:selected').val());
    // Get the material value
    materialVal = jQuery("#product_form_" + productID)
      .find(".js_product_var_change option:selected")
      .attr("data-option1");
    if (!materialVal) {
      materialVal = jQuery("#product_form_" + productID)
        .find('[name="option-Material"]:checked')
        .val();
    }
    // Get the color value
    colorVal = jQuery("#product_form_" + productID)
      .find('[name="Color"]:checked')
      .val();
    if (!colorVal) {
      colorVal = jQuery("#product_form_" + productID)
        .find('[name="option-Color"]:checked')
        .val();
    }
    if (!colorVal) {
      colorVal = jQuery("#product_form_" + productID)
        .find(".js_product_var_change option:selected")
        .attr("data-option3");
    }
  } else {
    if (jQuery('[name="Size"]').length > 0) {
      sizeVal = jQuery('[name="Size"]:checked').val();
    }
    if (sizeVal == "" || sizeVal == undefined) {
      sizeVal = jQuery('[name="Carat"]:checked').val();
    }
    if (sizeVal == "" || sizeVal == undefined) {
      sizeVal = jQuery('[name="option-Carat"]:checked').val();
    }
    materialVal = jQuery('[name="Material"]:checked').val();
    if (materialVal == "" || materialVal == undefined) {
      materialVal = jQuery('[name="option-Material"]:checked').val();
    }
    colorVal = jQuery('[name="Color"]:checked').val();
    if (colorVal == "" || colorVal == undefined) {
      colorVal = jQuery('[name="option-Color"]:checked').val();
    }
  }
  var replacePattern = /[\s~`!@#$%^&*(){}\[\];:"'<,>?\/\\|_+=-]/g;
  var trialcombinationValue = "";

  if (materialVal != "" && materialVal != undefined) {
    materialVal = $.trim(materialVal);
    trialcombinationValue += materialVal.replace(replacePattern, "_");
    trialcombinationName += "Material";
  }
  if (sizeVal != "" && sizeVal != undefined) {
    sizeVal = $.trim(sizeVal);
    trialcombinationValue += "###" + sizeVal.replace(replacePattern, "_");
    trialcombinationName += "###Size";
  }
  if (colorVal != "" && colorVal != undefined) {
    colorVal = $.trim(colorVal);
    trialcombinationValue += "###" + colorVal.replace(replacePattern, "_");
    trialcombinationName += "###Color";
  }
  return trialcombinationName + "@@@" + trialcombinationValue;
}
/*:::::::::::::::::::::::: Wishlist Code end here :::::::::::::::::::::::: */

// USPS BLOCKS -- START

$('.usps_blocks_slider').slick({
  centerMode: false,
  centerPadding: '10px',
  slidesToShow: 1,
  arrows: false,
  loop: false,
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick"
    },
    {
      breakpoint: 750,
      settings: {
        dots: true,
        slidesToShow: 1
      }
    }
  ]
});

/**************************** PDP PAGE SLIDER DOT CLICK ACTIVE JS START ***************************/
jQuery(document).on("click",".product--thumbnail_slider .slider_dots .slider_dot",function(){
  if(jQuery(".product--thumbnail_slider .slider_dots .slider_dot").length>0){
    jQuery(".product--thumbnail_slider .slider_dots .slider_dot").removeClass('active');
    jQuery(this).addClass('active');
    var currentActive = jQuery(this).attr('data-count');
    if(jQuery(".product--thumbnail_slider .thumbnail-slider").length>0){
      currentActive = (currentActive-1);
      jQuery(".product--thumbnail_slider .thumbnail-slider").find('.thumbnail-list').find('.thumbnail-list__item .thumbnail').eq(currentActive).trigger("click");
    }
  }
});
/**************************** PDP PAGE SLIDER DOT CLICK ACTIVE JS END ***************************/

// TESTIMONIAL SLIDER -- START
$('.testimonial__slider').slick({
  centerMode: false,
  centerPadding: '20px',
  slidesToShow: 4,
  dots: false,
  arrows: true,
  prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg fill="#FFFFFF" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.006 512.006" xml:space="preserve"><g><g><path d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"/></g></g></svg></button>',
  nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg fill="#FFFFFF" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.005 512.005" xml:space="preserve"><g><g><path d="M388.418,240.923L153.751,6.256c-8.341-8.341-21.824-8.341-30.165,0s-8.341,21.824,0,30.165L343.17,256.005 L123.586,475.589c-8.341,8.341-8.341,21.824,0,30.165c4.16,4.16,9.621,6.251,15.083,6.251c5.461,0,10.923-2.091,15.083-6.251 l234.667-234.667C396.759,262.747,396.759,249.264,388.418,240.923z"/></g></g></svg></button>',
  loop: false,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 1
      }
    },
  ]
});
// TESTIMONIAL SLIDER -- END

// BANNER COUNTDOWN -- START
  (function () {
    $('.banner_countdown_timer_box').each(function () {
      const $timer = $(this);
      const deadline = $timer.data('deadline');
      if (!deadline) return;

      const countDownDate = new Date(deadline).getTime();

      const countdownFunction = setInterval(function () {
        const now = new Date().getTime();
        const distance = countDownDate - now;

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        function renderDigits($el, value) {
          const str = value.toString().padStart(2, '0');
          if ($el.data("lastValue") !== str) {
            $el.data("lastValue", str);
            const html = str.split('').map(d => `<span class="digit">${d}</span>`).join('');
            $el.html(html);
          }
        }

        renderDigits($timer.find(".pt-timer-days"), days);
        renderDigits($timer.find(".pt-timer-hours"), hours);
        renderDigits($timer.find(".pt-timer-minutes"), minutes);
        renderDigits($timer.find(".pt-timer-seconds"), seconds);

        if (distance < 0) {
          clearInterval(countdownFunction);
          renderDigits($timer.find(".pt-timer-days"), 0);
          renderDigits($timer.find(".pt-timer-hours"), 0);
          renderDigits($timer.find(".pt-timer-minutes"), 0);
          renderDigits($timer.find(".pt-timer-seconds"), 0);
        }
      }, 1000);
    });
  })();
// BANNER COUNTDOWN -- END

// WAITLIST POPUP -- START


$(document).ready(function() {
    $('.join_waitlist_btnlink').on('click', function() {
        let productId = $(this).data('id'); 
        let productTitle = $(this).data('title');
        $('#product_id').val(productId);
        $('#product_title').val(productTitle);
        $('.waitlist-popup-section').addClass('active');
        $('body').addClass('waitlist-popup-active');
    });

    $('.waitlist_popup_close').on('click', function() {
        $('.waitlist-popup-section').removeClass('active');
        $('body').removeClass('waitlist-popup-active');
    });

    $('.register_link_wait').on('click', function() {
      $('.register_frm_waitlist').show();
      $('.login_frm_waitlist').hide();
    });

    $('.login_link_wait').on('click', function() {
      $('.register_frm_waitlist').hide();
      $('.login_frm_waitlist').show();
    });
});

$(document).ready(function() {
    $('.card_waitlist_btn_popup').on('click', function() {
        let productId = $(this).data('id');
        let productTitle = $(this).data('title');
        $('#product_id').val(productId);
        $('#product_title').val(productTitle);
        $('.waitlist-popup-section').addClass('active');
        $('#successmessage').hide();
        $('body').addClass('waitlist-popup-active');
    });

    $('.waitlist_popup_close').on('click', function() {
        $('.waitlist-popup-section').removeClass('active');
        $('body').removeClass('waitlist-popup-active');
    });
});

async function saveWishList(customerId="",productTitle="") {
  $('#error_message_small').hide();
  $("#error_message_small").text("");
  $('#successmessage').hide();

  if(customerId == ''){
    customerId = document.getElementById("customer_id").value;
    productTitle = document.getElementById("product_title").value;
    var email = $('#wishlistemail').val();

     var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(!email){
      $("#error_message_small").text("Email is required.");
      $("#error_message_small").show();
      return false;
    }

    if(!emailPattern.test(email)){
      $("#error_message_small").text("Please enter a valid email address.");
      $("#error_message_small").show();
      return false;
    }
  } 
  const url = `https://notify-app.gadget.app/add-customer-tag?customerId=${encodeURIComponent(customerId)}&tag=${encodeURIComponent(productTitle)}&email=${encodeURIComponent(email)}`;

  const res = await fetch(url);
  const data = await res.json();

  console.log("Response:", data);
  if(data.success){
    $('#successmessage').show();
    const btn = $(`button[data-title="${productTitle}"]`);
    if (btn.length) {
      btn.prop("disabled", true)
        .addClass("added")
        .css("cursor", "not-allowed")
        .html("<span>Added to Waitlist</span>");
    }

    if(customerId == ''){
      $('#wishlistemail').val('');
    }
    
  }else{
    $("#error_message_small").text("Something Went Wrong");
    $("#error_message_small").show();
  }
  //alert(data.success ? "Tag saved!" : "Error saving tag");
}

async function removeWishList(handle,customer_id) {
  if (!confirm("Are you sure you want to remove this item from your waitlist?")) {
    return;
  }
  const url = `https://notify-app.gadget.app/remove-customer-tag?customerId=${encodeURIComponent(customer_id)}&tag=${encodeURIComponent(handle)}`;

  const res = await fetch(url);
  const data = await res.json();

  if(data.success){
    handle_repl = handle.replace("waitlist$$", "");
    $('#handleid_'+handle_repl).remove();
    if ($(".waitlist-details tbody tr").length === 0) {
        $(".waitlist-details tbody").append('<tr><td colspan="3">No Data Found!</td></tr>');
    }
  }else{
    alert("Something Went Wrong");
  }
}


// WAITLIST POPUP -- END


/* load more code start here */
// start for load more button click data
function getAllURLParameters() {
  const urlParams = new URLSearchParams(window.location.search);
  const params = {};

  // Collect all parameters into an object
  urlParams.forEach((value, key) => {
    params[key] = value;
  });

  // Convert the object back to a query string
  const queryString = new URLSearchParams(params).toString();

  return queryString;
}

jQuery(document).ready(function () {
  let page = 2;
  let loading = false;
  let totalPerPage = jQuery("#per_page_collection").val();
  let totalCollectionProduct = jQuery("#collection_total_products").val();
  let totalPage = Math.ceil(totalCollectionProduct / totalPerPage);
  let collectionUrl = jQuery("#collection_url").val();

  if (
    totalPerPage != "" &&
    totalPerPage != undefined &&
    jQuery("#load-more-btn-wrapper").length != 0
  ) {
    let displayedProducts = jQuery("#product-grid").find(
      ".grid__item:not('.double-grid')"
    ).length;
    jQuery("#products-counter .showing-total-data").text(displayedProducts);
    // Attach click event to the "Load More" button
    jQuery(document).on("click", "#load-more-btn", function () {
      console.log("cliked");
      loadMore();
    });
    function loadMore() {
      if (!loading) {
        loading = true;
        if (totalPage >= page) {
          var dataParam = getAllURLParameters();
          console.log("dataParam", dataParam);
          var url =
            window.location.origin +
            collectionUrl +
            "?page=" +
            page +
            "&" +
            dataParam;
          $.get(url, function (data) {
            console.log("products data", data);
            var newProducts = $(data).find("#product-grid").html();
            if (newProducts.trim().length > 0) {
              $("#product-grid").append(newProducts);
              displayedProducts = jQuery("#product-grid").find(
                ".grid__item:not('.double-grid')"
              ).length;
              jQuery("#products-counter .showing-total-data").text(
                displayedProducts
              );
              page++; // Increment page only if new products are loaded
              /*console.log("displayedProducts",newProducts);
              if(parseInt(newProducts)<totalPerPage){
                jQuery("#load-more-btn-wrapper").hide();
              }*/
            }
            loading = false;
          }).fail(function () {
            loading = false; // Reset loading flag in case of failure
          });
        } else {
          loading = true;
          jQuery("#load-more-btn-wrapper").hide();
        }
      }
    }
  }
});
/* load more code end here */

/*wait list local storage start */

$(document).on("click", ".join_waitlist_btnlink1", function(e) {
  e.preventDefault();
  let productId = $(this).data("id");
  let productHandle = $(this).data("handle");
  let productTitle = $(this).data("title");
  let productUrl = $(this).data("url");
  let productPrice = $(this).data("price");
  let productImage = $(this).data("image");

  let email = localStorage.getItem("waitlist_email");
  let storedData = JSON.parse(localStorage.getItem("waitlist_data")) || {};
  
  if (email) {
    // $('.waitlist-popup-section-v2').addClass('active');
    // $('body').addClass('waitlist-popup--active');
    //$('#waitlist_v2_id').val(productId);
    //$('#waitlist_email').val(email).prop('readonly', true);
    
    saveWishlistV2(productId,productHandle,productTitle,productUrl,productPrice,productImage);
  }else {
    $('.waitlist-popup-section-v2').addClass('active');
    $('body').addClass('waitlist-popup--active');
    $('#waitlist_v2_id').val(productId);
    $('#waitlist_v2_handle').val(productHandle);
    $('#waitlist_v2_title').val(productTitle);
    $('#waitlist_v2_url').val(productUrl);
    $('#waitlist_v2_price').val(productPrice);
    $('#waitlist_v2_image').val(productImage);

  }

});

$('.waitlist_popup_close_v2').on('click', function() {
    $('.waitlist-popup-section-v2').removeClass('active');
    $('body').removeClass('waitlist-popup--active');
});

async function saveWishlistV2(productId='', productHandle='', productTitle='', productUrl='', productPrice='', productImage=''){
  let email = '';
  let customerId = localStorage.getItem("waitlist_customer_id") || '';
  let apiSuccess = true; 
  let apiErrorMsg = '';

  if(productId === '') {
    // From popup
    email = $('#waitlist_email').val();
    $('#error_message_small_v2').hide().text("");
    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if(!email){
      $("#error_message_small_v2").text("Email is required.").show();
      return false;
    }
    if(!emailPattern.test(email)){
      $("#error_message_small_v2").text("Please enter a valid email address.").show();
      return false;
    }

    // product details
    productId     = $('#waitlist_v2_id').val();
    productHandle = $('#waitlist_v2_handle').val();
    productTitle  = $('#waitlist_v2_title').val();
    productUrl    = $('#waitlist_v2_url').val();
    productPrice  = $('#waitlist_v2_price').val();
    productImage  = $('#waitlist_v2_image').val();
    var passproductHandle = 'waitlist$$'+productHandle;
    try {
      let url = '';
      if(customerId){ 
        // Returning user → only tag assign
        url = `https://notify-app.gadget.app/add-customer-tagv2?customerId=${encodeURIComponent(customerId)}&tag=${encodeURIComponent(passproductHandle)}`;
      } else { 
        // First time user → create customer + assign tag
        url = `https://notify-app.gadget.app/add-customer-tagv2?email=${encodeURIComponent(email)}&tag=${encodeURIComponent(passproductHandle)}`;
      }

      const res = await fetch(url);
      const data = await res.json();

      if (data.error || data.success === false) { 
        apiSuccess = false;
        apiErrorMsg = data.message || "Unable to join waitlist.";
      } else {
        // If customer created first time → save ID + email
        
        //alert(data.customer.id);
        if(!customerId){
          localStorage.setItem("waitlist_customer_id", data.customer.id);
          localStorage.setItem("waitlist_email", email);
        }
      }
    } catch (err) {
      apiSuccess = false;
      apiErrorMsg = "Something went wrong. Please try again.";
    }
  } else {
    // Product clicked directly
    email = localStorage.getItem("waitlist_email") || '';
    customerId = localStorage.getItem("waitlist_customer_id") || '';

    if(!customerId){
      $("#error_message_small_v2").text("Please enter email first.").show();
      return false;
    }
    var passproductHandle = 'waitlist$$'+productHandle;
    try {
      const url = `https://notify-app.gadget.app/add-customer-tagv2?customerId=${encodeURIComponent(customerId)}&tag=${encodeURIComponent(passproductHandle)}`;
      const res = await fetch(url);
      const data = await res.json();

      if (data.error || data.success === false) { 
        apiSuccess = false;
        apiErrorMsg = data.message || "Unable to join waitlist.";
      }
    } catch (err) {
      apiSuccess = false;
      apiErrorMsg = "Something went wrong. Please try again.";
    }
  }

  // Stop if API failed
  if(!apiSuccess){
    $("#error_message_small_v2").text(apiErrorMsg).show();
    return false;
  }

  // Save product data
  let storedData = JSON.parse(localStorage.getItem("waitlist_data")) || {};
  if (!storedData[email]) {
      storedData[email] = [];
  }

  let exists = storedData[email].some(p => p.id == productId);
  if (!exists) {
      storedData[email].push({
          id: productId,
          handle: productHandle,
          title: productTitle,
          url: productUrl,
          price: productPrice,
          image: productImage
      });
      localStorage.setItem("waitlist_data", JSON.stringify(storedData));

      // Update buttons
      let wrapper = $(`.waitlist-buttons`).has(`.join[data-id='${productId}']`);
      wrapper.find(".join").hide();
      wrapper.find(".added").show();

      let wrapper2 = $(`.card__waitlist_v2`).has(`.join[data-id='${productId}']`);
      wrapper2.find(".join").hide();
      wrapper2.find(".added").show();

      // Close popup on success
      $('.waitlist-popup-section-v2').removeClass('active');
      $('body').removeClass('waitlist-popup--active');
  }
}


$(document).ready(function () {
    let storedData = JSON.parse(localStorage.getItem("waitlist_data")) || {};
    let email = localStorage.getItem("waitlist_email");
    $(".waitlist-buttons").each(function () {
        let joinBtn = $(this).find(".join");
        let addedBtn = $(this).find(".added");
        let productId = joinBtn.data("id");
        if (email && storedData[email]) {
            // check if product exists in waitlist for this email
            let exists = storedData[email].some(p => p.id == productId);

            if (exists) {
                // Show "Added to Waitlist"
                addedBtn.show();
                joinBtn.hide();
            } else {
                // Show "Join the waitlist1"
                joinBtn.show();
                addedBtn.hide();
            }
        } else {
            // No email yet → allow user to join
            joinBtn.show();
            addedBtn.hide();
        }
    });

    $(".card__waitlist_v2").each(function(){
      let productId = $(this).data("id");
      let joinBtn = $(this).find(".join");
      let addedBtn = $(this).find(".added");
      if (email && storedData[email]) {
            // check if product exists in waitlist for this email
          let exists = storedData[email].some(p => p.id == productId);

          if (exists) {
              // Show "Added to Waitlist"
              addedBtn.show();
              joinBtn.hide();
          } else {
              // Show "Join the waitlist1"
              joinBtn.show();
              addedBtn.hide();
          }
      } else {
          // No email yet → allow user to join
          joinBtn.show();
          addedBtn.hide();
      }
    })

    let wishlistEl = document.querySelector("#guest-wishlist");
    if (wishlistEl) {
      if (email && storedData[email] && storedData[email].length > 0) {
        storedData[email].forEach(product => {
          let html = `
            <li class="grid__item scroll-trigger animate--slide-in" id="guest_handleid_${product.handle}">
              <div class="wishlist-product__list card-wrapper product-card-wrapper underline-links-hover">
                <div class="card card--standard card--media" style="--ratio-percent: 125.0%;">
                  <div class="card__inner color-scheme-1 gradient ratio" style="--ratio-percent: 125.0%;">
                    <div class="card__media">
                      <div class="media media--transparent media--hover-effect">
                        <a href="${product.url}">
                          <img src="${product.image}" alt="${product.title}">
                        </a>
                      </div>
                    </div>
                    <div class="card__content">
                      <div class="card__information">
                        <h3 class="card__heading">
                          <a href="${product.url}" class="full-unstyled-link">${product.title}</a>
                        </h3>
                      </div>
                      <div class="card__badge bottom left"></div>
                    </div>
                  </div>
                  <div class="card__content">
                    <div class="card__information">
                      <h3 class="card__heading h5">
                        <a href="${product.url}" class="full-unstyled-link">${product.title}</a>
                      </h3>
                      <div class="card-information">
                        <span class="caption-large light"></span>
                        <div class="price">
                          <div class="price__container">
                            <div class="price__regular">
                              <span class="visually-hidden visually-hidden--inline">Regular price</span>
                              <span class="price-item price-item--regular">
                                ${product.price}
                              </span>
                            </div>
                            <div class="price__sale">
                              <span class="visually-hidden visually-hidden--inline">Regular price</span>
                              <span><s class="price-item price-item--regular"></s></span>
                              <span class="visually-hidden visually-hidden--inline">Sale price</span>
                              <span class="price-item price-item--sale price-item--last">
                                ${product.price}
                              </span>
                            </div>
                            <small class="unit-price caption hidden">
                              <span class="visually-hidden">Unit price</span>
                              <span class="price-item price-item--last">
                                <span></span>
                                <span aria-hidden="true">/</span>
                                <span class="visually-hidden">&nbsp;per&nbsp;</span>
                                <span></span>
                              </span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <button onclick="removeGuestWishList('${product.handle}')">
                        Remove
                      </button>
                      <div class="card__badge bottom left"></div>
                    </div>
                  </div>
                </div>
              </div>
            </li>`;
          wishlistEl.insertAdjacentHTML("beforeend", html);
        });
      } else {
        wishlistEl.innerHTML = "<p>No items in your waitlist.</p>";
      }
    }
});


async function removeGuestWishList(productHnadle) {
  var customerId = localStorage.getItem("waitlist_customer_id") || '';
  let email = localStorage.getItem("waitlist_email");
  let storedData = JSON.parse(localStorage.getItem("waitlist_data")) || {};

 
  var passproductHnadle = 'waitlist$$'+productHnadle;
  const url = `https://notify-app.gadget.app/remove-customer-tag?customerId=${encodeURIComponent(customerId)}&tag=${encodeURIComponent(passproductHnadle)}`;

  const res = await fetch(url);
  const data = await res.json();

  if(data.success){
     if (email && storedData[email]) {
      storedData[email] = storedData[email].filter(p => p.handle != productHnadle);
      localStorage.setItem("waitlist_data", JSON.stringify(storedData));
      document.querySelector(`#guest_handleid_${productHnadle}`)?.remove();
    }
  }else{
    alert("Something Went Wrong");
  }
  
}

/*wait list local storage end */


document.addEventListener("DOMContentLoaded", function () {
  const viewCountEl = document.getElementById("viewCount");

  if (viewCountEl) {
    function getRandomViewCount(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function updateViewCount() {
      const newCount = getRandomViewCount(3, 20); // Change range if needed
      viewCountEl.textContent = newCount;
    }

    // Initial update
    updateViewCount();

    // Repeat every 2 minutes
    setInterval(updateViewCount, 60000);
  }
});

// Set target date (change to your desired date)
const targetDate = new Date("Nov 30, 2025 23:59:59").getTime();

function updateCountdown() {
  const daysEl = document.getElementById("days");
    const hoursEl = document.getElementById("hours");
    const minEl = document.getElementById("minutes");
    const secEl = document.getElementById("seconds");

    if (!daysEl || !hoursEl || !minEl || !secEl) return; // stop if ANY are missing

    const now = new Date().getTime();
    const distance = targetDate - now;

    if (distance < 0) return;

    document.getElementById("days").textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
    document.getElementById("hours").textContent = Math.floor((distance / (1000 * 60 * 60)) % 24);
    document.getElementById("minutes").textContent = Math.floor((distance / (1000 * 60)) % 60);
    document.getElementById("seconds").textContent = Math.floor((distance / 1000) % 60);
}

updateCountdown();
setInterval(updateCountdown, 1000);




//CART DRAWER UPSELL PRODUCT SLIDER AND ADD TO CART JS START
jQuery(document).on("click",".header__icon--cart span.svg-wrapper",function(){
  setTimeout(function(){
    upsellSliderCart();
  },10);
});
let totalSlideUpsell = 0;
let ignoreSlideCount = 0;

function upsellSliderCart() {
  var sliderId = setInterval(function() {
    var $drawer = jQuery('.cart__drawer_main');
    var $slider = $drawer.find('.other_flavor_grid');

    if ($drawer.hasClass('active') !== undefined && $slider.length) {
      sliderUpsell();
      // collect indexes to remove
      setTimeout(function(){
        var indexesToRemove = [];
        $slider.find('.other_flavor-card.ignore-slide').each(function() {
          var index = jQuery(this).closest('.slick-slide').attr('data-slick-index');
          if (index !== undefined) {
            indexesToRemove.push(parseInt(index));
          }
        });

        // remove in descending order
        indexesToRemove.sort(function(a, b){ return b - a; });
        indexesToRemove.forEach(function(i) {
          $slider.slick('slickRemove', i);
        });

        // Refresh or destroy slick if needed
        if ($slider.hasClass('slick-initialized')) {
          const remainingSlides = $slider.find('.slick-slide').not('.slick-cloned').length;

          if (remainingSlides <= 1) {
            $slider.slick('unslick');
          } else {
            $slider.slick('setPosition');
          }
        }

        clearInterval(sliderId);
      }, 1000);
    }

    hideshowUpsell();
  }, 10);
}

function hideshowUpsell(){
  if(jQuery('.drawer__footer').find('.other_flavor_grid').length>0) {
    totalSlideUpsell = jQuery('.drawer__footer').find('.other_flavor_grid').slick('getSlick').slideCount;
    ignoreSlideCount = jQuery('.drawer__footer').find('.other_flavor-card.ignore-slide').length;
    var countShow = jQuery('.drawer__footer').find('.other_flavor-card:not(.ignore-slide)').length;
    //console.log("countShow",countShow,ignoreSlideCount);
    jQuery('.drawer__footer').find('.other_flavor').show();
    if(countShow<=1){
      if(countShow == 0){
        if(jQuery('.drawer__footer').find('.other_flavor').length>0){
          jQuery('.drawer__footer').find('.other_flavor').hide();
        }       
      }
    }
  }
}

jQuery(document).on("click",".cart-items .cart-remove-button",function(){
  setTimeout(function(){
    upsellSliderCart();
  },1500);
});

jQuery(document).on("click",".drawer__cart-items-wrapper [name='minus'],.drawer__cart-items-wrapper [name='plus']",function(){
  var otherflavorId = setInterval(function(){
    if(!jQuery('.cart__drawer_main').find('.other_flavor_grid').hasClass('slick-initialized')) {
      sliderUpsell();
      clearInterval(otherflavorId);
    }
  },500);
});

function sliderUpsell(){
  if(jQuery('.cart__drawer_main').find('.other_flavor_grid').length>0){
    if(jQuery('.cart__drawer_main').find('.other_flavor_grid').hasClass('slick-initialized')) {
      jQuery('.cart__drawer_main').find('.other_flavor_grid').slick('unslick');
    }

      jQuery('.cart__drawer_main').find('.other_flavor_grid').slick({
        dots: false,
        arrows: true,
        prevArrow:
          '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.9493 8.45734L13.8306 10.348L9.4706 14.688L27.6106 14.7053L27.6079 17.372L9.51726 17.3547L13.8039 21.6613L11.9146 23.5413L4.38926 15.9813L11.9493 8.45734Z" fill="black"/></svg></button>',
        nextArrow:
          '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0507 8.45734L18.1694 10.348L22.5294 14.688L4.3894 14.7053L4.39207 17.372L22.4827 17.3547L18.1961 21.6613L20.0854 23.5413L27.6107 15.9813L20.0507 8.45734Z" fill="black"/></svg></button>',
        infinite: false,
        slidesToShow: 1.3,
        slidesToScroll: 1
      });
  }
}


/* CART DRAWER UPSELL */
jQuery(document).on("click", ".other_flavor_grid .routine_product_btn.routine_add_Cart", function (e) {
  var pid = jQuery(this).attr('data-pid');
  //console.log("pid",pid);
  jQuery(this).hide();
  jQuery(this).addClass("btn--loading");
  var vid = parseInt(jQuery(this).attr("data-vid"));
  var data = {};
  var dataType = [];
  data["id"] = vid;
  data["quantity"] = 1;
  dataType.push(data);
  const newData = {
    items: dataType,
  };
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: newData,
    dataType: "json",
    success: function (data) {
      //console.log("data",data);
      if(jQuery('.other_flavor_grid').find('.other_flavor-card[data-col-pid="'+pid+'"]').length>0){
        jQuery('.other_flavor_grid').find('.other_flavor-card[data-col-pid="'+pid+'"]').removeClass('slide-main');
        jQuery('.other_flavor_grid').find('.other_flavor-card[data-col-pid="'+pid+'"]').addClass('ignore-slide');
      }
      refreshCartDrawer();
    },
  });

  setTimeout(function () {
    jQuery(".add__btn_custom__upsell").show();
    jQuery(".add__custom_loader").hide();
    jQuery('[cart-product--id="' + pid + '"]').hide();
  }, 1550);
});

function refreshCartDrawer() {
  jQuery.get('/cart?view=drawer', function(html) {
    var $currentTable = jQuery('.cart__drawer_main .cart-items__table');

    if ($currentTable.length) {
      // Update cart rows (exclude header)
      var $newRows = jQuery(html)
        .find('.cart-items__table-row')
        .not(':has(th)');

      $currentTable.find('.cart-items__table-row').not(':has(th)').remove();
      $currentTable.append($newRows);
    }

    // Update totals
    var $newTotals = jQuery(html).find('.cart__summary-totals');
    var $currentTotals = jQuery('.cart__summary-totals');
    if ($newTotals.length && $currentTotals.length) {
      $currentTotals.replaceWith($newTotals);
    }
    jQuery.getJSON('/cart.js', function(cart) {
      var totalQuantity = cart.item_count;     // total items (sum of quantities)
      var totalProducts = cart.items.length;   // total unique products
      if(jQuery('.drawer_heading_wrapper').find('.drawer_heading_count').length>0){
        jQuery('.drawer_heading_wrapper').find('.drawer_heading_count').text(totalQuantity+' items');
      }
    });
    // Reinitialize quantity selectors and sliders
    //reinitQuantitySelectors();
    
  });
  setTimeout(function(){
    upsellSliderCart();
    //hideshowUpsell();
  },1000);
}

function reinitQuantitySelectors() {
  jQuery('.cart__drawer_main quantity-selector-component').each(function() {
    // your theme may have a global function to initialize them
    if (typeof this.connectedCallback === 'function') {
      this.connectedCallback(); // triggers web component init
    }
  });
}

/* CART DRAWER UPSELL */
//CART DRAWER UPSELL PRODUCT SLIDER AND ADD TO CART JS END

//PROGRESSBAR CART DRAWER JS STARTED
function getProgressData() {
  var getCurrency = 'AED';
  if(jQuery('.doubly-wrapper').find('.currency-switcher').length>0){
    getCurrency = jQuery('.doubly-wrapper').find('.currency-switcher').find('option:selected').val();
  }
   $.ajax({
    url: "/cart",
    dataType: "json",
    error: function (items) {
      //console.error(items[0]);
      //loadingBarTrigger("done");
    },
    success: function (cart) {
      if (jQuery('.cart__drawer_main').find('.cart_progress_wrapper').length > 0) {
        var objAttr = jQuery('.cart__drawer_main').find('.drawer__inner');
        var goal1    = parseInt(objAttr.attr('data-goal1'));
        var totalCart = cart.original_total_price;

        var drawerObj = '';
        if(jQuery('.cart__drawer_main').find('.cart_progress_fill').length>0){
          drawerObj = jQuery('.cart__drawer_main').find('.cart_progress_fill');
        }
        var progressWidth = 0;
        var remainAmount = 0;
        if(goal1>totalCart){
          remainAmount = parseInt(goal1-totalCart);
        }
        if (totalCart <= goal1) {
          progressWidth = (totalCart / goal1) * 100;
        }
        // --- Reached Goal 4 (Max) ---
        else if (totalCart >= goal1) {
          progressWidth = 100;
        }
        if(progressWidth<100){
          jQuery('.cart__drawer_main').find('.cp_congrats_label').hide();
          jQuery('.cart__drawer_main').find('.cp_first_label').show();
          remainAmount = (remainAmount/100);
          if(remainAmount>0){
            jQuery('.cart__drawer_main').find('.remain-amount').text(getCurrency+' '+remainAmount.toFixed(2));
          }
        }else if(jQuery('.cart__drawer_main').find('.cp_congrats_label').length>0){
          jQuery('.cart__drawer_main').find('.cp_first_label').hide();
          jQuery('.cart__drawer_main').find('.cp_congrats_label').show();
        }
        if(jQuery('.cart__drawer_main').find('.cart_progress_fill').length>0){
          jQuery('.cart__drawer_main').find('.cart_progress_fill').css("width", progressWidth + "%");
        }
      }
    }
  });
}

jQuery(document).ready(function($){
    setInterval(function(){
     getProgressData();
    },500);
});

jQuery(document).on("click", ".gift_custom_mess", function (e) {
  jQuery("#gift_warp_popupOverlay").addClass("active");
  jQuery("#gift_warp_popupBox").addClass("active");
  if(jQuery(this).attr('data-val') != ''){
    jQuery('.gift-textarea').val(jQuery(this).attr('data-val'));
  }
});

jQuery(document).on("click", ".gift-btn", function (e) {
  var customMes = jQuery('.gift-textarea').val();
  var vid = 47513507758180;
  if(customMes != ''){
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: {
        id: vid,
        quantity: 0
      },
      dataType: "json",
      success: function(cart) {
        var data = {
          id: vid,
          quantity: 1,
          properties: {
            "Custom Gift Wrap Message": customMes
          }
        };
        const newData = {
          items: [data]
        };
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: JSON.stringify(newData),
          dataType: "json",
          success: function (data) {
            //console.log("data",data);
            refreshCartDrawer();
            jQuery('.giftwrap-title').html('Gift Warp Added <span class="gift_custom_mess" data-val="'+customMes+'">Edit Message</span>');
            jQuery("#gift_warp_popupOverlay").removeClass("active");
            jQuery("#gift_warp_popupBox").removeClass("active");
          },
        });
      },
      error: function(err) {
        console.error(err);
      }
    });
  }
});

jQuery(document).on("change", "#gidftwrap_custom", function (e) {
  //e.preventDefault();
  if ($(this).is(':checked')) {
    // jQuery("#gift_warp_popupOverlay").addClass("active");
    // jQuery("#gift_warp_popupBox").addClass("active");
    
    $(this).attr("checked", "checked");
    $(this).prop("checked", "checked");
    var vid = 47513507758180;
    var customMess = document.getElementById("custom_text_pro").value;
    console.log("customMess--->", customMess)
    if(customMess != ''){
      var data = {
        id: vid,
        quantity: 1,
        properties: {
          "Custom Gift Wrap Message": customMess
        }
      };
    }
    else{
      var data = {
        id: vid,
        quantity: 1,
      };
    }
    const newData = {
      items: [data]
    };
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: JSON.stringify(newData),
      dataType: "json",
      success: function (data) {
        //console.log("data",data);
        refreshCartDrawer();
        jQuery('.giftwrap-title').html('Gift Warp Added <span class="gift_custom_mess" data-val="">Add Message</span>')
      },
    });
  }
  else{
    var vid = 47513507758180;
    $(this).attr("checked", false);
    $(this).prop("checked", false);
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: {
        id: vid,
        quantity: 0
      },
      dataType: "json",
      success: function(cart) {
        refreshCartDrawer();
        jQuery('.giftwrap-title').html('Add Gift wrap for AED 10');
      },
      error: function(err) {
        console.error(err);
      }
    });

  }
});

jQuery(document).ready(function ($) {
  $('.adv_featured_collection_grid').hide();
  $('ul.collection-tab li:first').addClass('active');
  $('.adv_featured_collection_grid:first').show();
  $('ul.collection-tab li').on('click', function (e) {
    e.preventDefault();
    $('ul.collection-tab li').removeClass('active');
    
    $(this).addClass('active');
    let tabId = $(this).data('id');
    $('.adv_featured_collection_grid').hide();
    $('#' + tabId).show();
  });
});

$('.bf-slider').slick({
  centerMode: false,
  slidesToShow: 4,
  arrows: true,
  loop: true,
  prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg fill="#FFFFFF" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.006 512.006" xml:space="preserve"><g><g><path d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"/></g></g></svg></button>',
  nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg fill="#FFFFFF" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.005 512.005" xml:space="preserve"><g><g><path d="M388.418,240.923L153.751,6.256c-8.341-8.341-21.824-8.341-30.165,0s-8.341,21.824,0,30.165L343.17,256.005 L123.586,475.589c-8.341,8.341-8.341,21.824,0,30.165c4.16,4.16,9.621,6.251,15.083,6.251c5.461,0,10.923-2.091,15.083-6.251 l234.667-234.667C396.759,262.747,396.759,249.264,388.418,240.923z"/></g></g></svg></button>',
  autoplay: true,
  autoplaySpeed:2000,
  responsive: [
    {
      breakpoint: 991,
      settings: "unslick"
    }
  ]
});

function initMobileSlick() {
  if ($(window).width() < 992) {
    if (!$('.shop_combos_grid').hasClass('slick-initialized')) {
      $('.shop_combos_grid').slick({
        mobileFirst: true,
        slidesToShow: 1,
        arrows: false,
        infinite: false
      });
    }
  } else {
    if ($('.shop_combos_grid').hasClass('slick-initialized')) {
      $('.shop_combos_grid').slick('unslick');
    }
  }
}

$(document).ready(initMobileSlick);
$(window).on('resize', initMobileSlick);
